var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0127C24.8366 32.0127 32 24.8493 32 16.0127C32 7.17614 24.8366 0.0126953 16 0.0126953C7.16344 0.0126953 0 7.17614 0 16.0127C0 24.8493 7.16344 32.0127 16 32.0127Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0128C0 22.0774 3.37438 27.3537 8.34781 30.0673V1.95819C3.37438 4.67182 0 9.94807 0 16.0128Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0049 21.5779C31.648 19.8446 32 17.9698 32 16.0127C32 14.0556 31.648 12.1808 31.0049 10.4475H0.99525C0.352062 12.1808 0 14.0556 0 16.0127C0 17.9698 0.352062 19.8446 0.99525 21.5779L16 22.9692L31.0049 21.5779Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 32.0127C22.8796 32.0127 28.7442 27.6707 31.005 21.5779H0.995361C3.25599 27.6707 9.12074 32.0127 16.0001 32.0127V32.0127Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0126C0 23.405 5.01381 29.6254 11.8261 31.4614V0.563782C5.01381 2.39978 0 8.62016 0 16.0126Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78838 7.0536L8.31269 5.57791L7.32894 6.56179L6.3452 5.57791L4.86951 7.0536L5.85332 8.03741L4.86938 9.02129L6.34507 10.497L7.32888 9.5131L8.31269 10.497L9.78838 9.02129L8.80457 8.03741L9.78838 7.0536Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOman);
export default __webpack_public_path__ + "static/media/oman.bd8d12c0.svg";
export { ForwardRef as ReactComponent };